module.exports = __webpack_public_path__ + "static/img_0031_dpp_optimized-98a61930c1d4f15ed88ecc30346abc74.jpg";